import { Outlet } from 'react-router-dom';

import { CssBaseline, GlobalStyles, styled } from '@sbv-clients/ui-shared';

const Root = styled('div')`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AuthLayoutProps {}

const PublicRouteLayout = (props: AuthLayoutProps) => {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyles />
      <Outlet />
    </Root>
  );
};

export default PublicRouteLayout;
